module.exports = __webpack_public_path__ + "23a1461610c2970c93a544ce9df11776.png";